// YouTube URL helpers — safely convert any YouTube link into a proper embeddable URL.
// Supported inputs:
//   https://www.youtube.com/watch?v=VIDEO_ID (+ extra params)
//   https://youtu.be/VIDEO_ID
//   https://youtube.com/shorts/VIDEO_ID
//   https://www.youtube.com/embed/VIDEO_ID
//   https://www.youtube.com/live/VIDEO_ID
//   https://www.youtube-nocookie.com/embed/VIDEO_ID

export const getYouTubeId = (url) => {
  if (!url) return '';
  const s = String(url).trim();
  const patterns = [
    /youtube(?:-nocookie)?\.com\/watch\?(?:.*&)?v=([A-Za-z0-9_-]{6,20})/,
    /youtube(?:-nocookie)?\.com\/(?:embed|shorts|live|v)\/([A-Za-z0-9_-]{6,20})/,
    /youtu\.be\/([A-Za-z0-9_-]{6,20})/,
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m) return m[1];
  }
  return '';
};

// Converts any YouTube URL to an embed URL. Non-YouTube URLs that already look like
// embeds (e.g., Rumble /embed/) are passed through unchanged so existing content keeps working.
export const toYouTubeEmbed = (url, { privacy = true, autoplayMuted = false } = {}) => {
  const id = getYouTubeId(url);
  if (!id) {
    if (url && /\/embed(\/|\?|$)/i.test(String(url))) return String(url).trim();
    return '';
  }
  const host = privacy ? 'www.youtube-nocookie.com' : 'www.youtube.com';
  const params = new URLSearchParams({ rel: '0' });
  if (autoplayMuted) {
    params.set('autoplay', '1');
    params.set('mute', '1'); // autoplay is ALWAYS muted — never with sound
  }
  return `https://${host}/embed/${id}?${params.toString()}`;
};
